import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container q-mt-md q-mb-xl" }
const _hoisted_2 = { class: "row q-col-gutter-lg" }
const _hoisted_3 = { class: "col-12 col-md-3" }
const _hoisted_4 = { class: "flex column q-gutter-md" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "c-avatar" }
const _hoisted_7 = { class: "text-grey-6" }
const _hoisted_8 = { class: "text-grey-6" }
const _hoisted_9 = {
  key: 0,
  class: "text-center"
}
const _hoisted_10 = { class: "q-mt-md" }
const _hoisted_11 = { class: "row q-col-gutter-md" }
const _hoisted_12 = {
  key: 0,
  class: "col-12"
}
const _hoisted_13 = { class: "text-h3 font-inter q-mb-md" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "col-12" }

import {computed, ref} from 'vue';
import {useRoute} from 'vue-router';
import ProfileName from 'src/components/etc/ProfileName.vue';
import ProfileAdvertList from 'src/components/profile/ProfileAdvertList.vue';
import {PublicUser} from 'src/models/user';
import {useMeta} from 'quasar';
import MessageUserButton from 'src/components/adverts/MessageUserButton.vue';
import Filter from 'src/etc/qutils/filter';
import ProfileItemList from 'components/profile/ProfileItemList.vue';
import FooterBar from 'components/FooterBar.vue';


import {useMainStore} from 'stores/main';

const __default__ = {
  preFetch({store, currentRoute, redirect, urlPath}) {
    const mainStore = useMainStore(store)
    return mainStore.fetchUserProfile(currentRoute.params.uuid).catch(err => {
      const {response} = err
      if ([404, 400].includes(response?.status)) {
        redirect({name: '404', query: {url: urlPath}})
      }
    })
  }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PublicProfilePage',
  setup(__props) {

const mainStore = useMainStore()
const user = ref<PublicUser | undefined>()
const route = useRoute()

const uuid = route.params.uuid.toString()
user.value = mainStore.userProfiles[uuid]


const dateJoined = computed(() => {
  let d = user.value?.date_joined
  if (!d) return
  return new Date(d).toLocaleDateString('de', {
    month: 'short',
    year: 'numeric'
  })
})

useMeta(() => {
  const user = mainStore.userProfiles[uuid]
  if (!user) return {}
  return {
    // sets document title
    titleTemplate(title) {
      return `${user?.name} auf ${title}`
    },

    link: [{rel: 'canonical', href: `${process.env.BASE_URL}${route.fullPath}`}],

    meta: {
      equiv: {
        'http-equiv': 'Content-Type',
        content: 'text/html; charset=UTF-8',
      },

      description: {
        name: 'description',
        template() {
          return `Aktuelle Camper von ${user.name} die zum Verkauf stehen. Ob professioneller Ausbau, ohne Ausbau oder Selbstausbau. Finde den passenden Camper.`
        }
      },
      ogType: {
        property: 'og:type',
        template() {
          return 'og:profile'
        },
      },

      ogUsername: {
        property: 'og:username',
        template() {
          return `${user?.name}`
        },
      },

      // note: for Open Graph type metadata you will need to use SSR, to ensure page is rendered by the server
      ogTitle: {
        property: 'og:title',

        // optional; similar to titleTemplate, but allows templating with other meta properties
        template() {
          return `${user?.name || ''} auf Camper Trader`
        },
      },
      ogDescription: {
        property: 'og:description',
        template() {
          return `${user?.about_me_clean || ''}`
        },
      },

      twitterCard: {
        property: 'twitter:card',
        template() {
          return 'summary_large_image'
        }
      },
      twitterSite: {
        property: 'twitter:site',
        template() {
          return '@CamperTrader_de'
        }
      },
      twitterCreator: {
        property: 'twitter:creator',
        template() {
          return '@CamperTrader_de'
        }
      },
      twitterTitle: {
        property: 'twitter:title',
        template() {
          return `${user?.name || ''} auf Camper Trader`
        }
      },
      twitterDescription: {
        property: 'twitter:description',
        template() {
          return `${user?.about_me_clean || ''}`
        }
      },

    },
  } as object
})


return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (user.value)
      ? (_openBlock(), _createBlock(_component_q_page, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_q_img, {
                          src: user.value.avatar?.path,
                          alt: "Profile image"
                        }, null, 8, ["src"])
                      ]),
                      _createVNode(ProfileName, {
                        owner: user.value,
                        class: "q-my-sm inline-block",
                        "disable-link": ""
                      }, null, 8, ["owner"]),
                      _createElementVNode("div", _hoisted_7, "Aktiv seit " + _toDisplayString(dateJoined.value), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(user.value.adverts_num) + " " + _toDisplayString(_unref(Filter).pluralize(user.value.adverts_num, 'Inserat', 'Inserate')) + " online ", 1)
                    ]),
                    (_unref(mainStore).accountDetail?.uuid !== _unref(uuid))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(MessageUserButton, {
                            rounded: "",
                            "show-modal": false,
                            "user-uuid": _unref(uuid)
                          }, null, 8, ["user-uuid"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", {
                  style: _normalizeStyle({paddingTop: !_ctx.$q.screen.lt.md ? '75px' : undefined}),
                  class: "col-12 col-md-9"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      (user.value.about_me)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, "Über " + _toDisplayString(user.value.name), 1),
                            _createElementVNode("div", null, _toDisplayString(user.value.about_me), 1),
                            _createVNode(_component_q_separator, { class: "q-mt-md" })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(ProfileItemList, { "user-uuid": _unref(uuid) }, null, 8, ["user-uuid"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(ProfileAdvertList, { "user-uuid": _unref(uuid) }, null, 8, ["user-uuid"])
                      ])
                    ])
                  ])
                ], 4)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.$q.platform.is.nativeMobile)
      ? (_openBlock(), _createBlock(FooterBar, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})